module.exports = __webpack_public_path__ + "static/media/playerthumbnail.363aa65a.png";